import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import {
  ChangePasswordFormFields,
  validationSchema,
} from 'shared/types/change-password-form';

export const useChangePasswordForm = (
  submit: (forgotPasswordData: ChangePasswordFormFields) => void,
) => {
  const { handleSubmit, ...formProps } = useForm<ChangePasswordFormFields>({
    resolver: yupResolver(validationSchema),
    mode: 'onSubmit',
  });

  const onSubmit = handleSubmit((data) => submit(data));

  return {
    ...formProps,
    onSubmit,
    errors: formProps.formState.errors,
    isValid: formProps.formState.isValid,
  };
};
